<template>
	<div style="width: 100%;height: 100%;background: #eceef1;">
		<Layout-Top border menuName="上传身份证" prevUrl="/WeChat/Person/Account/IdCard">
		</Layout-Top>
		<!-- <Row type="flex" justify="center" align="center" style="height: 46px;width: 100%; background: #eceef1;line-height: 46px;">
			<Col span="2">
				<Icon style="margin-top: -2px;" size="28" type="ios-arrow-back" />
			</Col>
			<Col span="22">
				上传身份证 
			</Col>
		</Row>
		<Divider style="margin-top: 0px;height: 2px;" /> -->
		<div style="height: 50px;width: 100%;text-align: center;">
			*请上传本人真实身份证*
		</div>
		<div style="width: 100%;padding-top: 42px;height: 180px;background:#f8f8f9 ;">
			<Row type="flex" justify="center" align="center" style="height: 88px;width: 100%;">
				<Col span="12">
					<div @click="selectIdCard('just')" style="height: 100%;width: 130px;position: relative;margin: 0 auto;">
						<img style="height: 88px;"  src="../../../../../../../assets/image/idcard_just.png" />
						<Icon size="38" style="position: absolute;top: 22px;left: 48px;" type="ios-camera" />
						<img v-if="idcard.justUrl!=''" style="position: absolute;height: 80px;width: 120px;top: 4px;left: 5px;" :src="idcard.justUrl" />
						<input @change="idcardChang('just')" ref="idcard_just" style="display: none;" type="file" accept="image/*" />
					</div>
				</Col>
				<Col span="12">
					<div  @click="selectIdCard('back')" style="height: 100%;width: 130px;position: relative;margin: 0 auto;">
						<img style="height: 88px;"  src="../../../../../../../assets/image/idcard_back.png" />
						<Icon size="38" style="position: absolute;top: 22px;left: 48px;" type="ios-camera" />
						<img v-if="idcard.backUrl!=''" style="position: absolute;height: 80px;width: 120px;top: 4px;left: 5px;" :src="idcard.backUrl" />
						<input @change="idcardChang('back')" ref="idcard_back" style="display: none;" type="file" accept="image/*" />
					</div>
				</Col>
			</Row> 
			<Row type="flex" justify="center" align="center" style="height: 30px;width: 100%;line-height: 30px;">
				<Col span="12" style="text-align: center;">
					身份证人像面
				</Col>
				<Col span="12" style="text-align: center;">
					身份证国徽面
				</Col>
			</Row>
		</div>
		<div style="height: 26px;width: 100%;line-height: 26px;font-size: 14px;font-weight: 600;margin: 6px auto;padding-left: 10px;">
			身份证拍摄示例:
		</div>
		<Row type="flex" justify="center" align="center" style="height: 80px;">
			<Col span="6" style="text-align: center;">
				<div style="width: 80px;height: 49px;position: relative;margin:0 auto;margin-bottom:8px ;">
					<img style="width: 80px;"  src="../../../../../../../assets/image/idcard_sl.png" />
					<Icon color="#19be6b" type="ios-checkmark-circle" size="18" style="position: absolute;bottom: -8px;left: 31px;" />
				</div>
				标准
			</Col>
			<Col span="6" style="text-align: center;">
				<div style="width: 80px;height: 49px;position: relative;margin:0 auto;margin-bottom:8px;padding-left: 16px;">
					<div style="width: 100%;height: 100%;overflow: hidden;">
						<img style="width: 80px;"  src="../../../../../../../assets/image/idcard_sl.png" />
					</div>
					<Icon color="#ed4014" type="ios-close-circle" size="18" style="position: absolute;bottom: -8px;left: 31px;" />
				</div>
				边框缺失
			</Col>
			<Col span="6" style="text-align: center;">
				<div style="width: 80px;height: 49px;position: relative;margin:0 auto;margin-bottom:8px ;">
					<img style="width: 80px;"  src="../../../../../../../assets/image/idcard_sl3.png" />
					<Icon color="#ed4014" type="ios-close-circle" size="18" style="position: absolute;bottom: -8px;left: 31px;" />
				</div>
				模糊
			</Col>
			<Col span="6" style="text-align: center;">
				<div style="width: 80px;height: 49px;position: relative;margin:0 auto;margin-bottom:8px ;">
					<img style="width: 80px;"  src="../../../../../../../assets/image/idcard_sl4.png" />
					<Icon color="#ed4014" type="ios-close-circle" size="18" style="position: absolute;bottom: -8px;left: 31px;" />
				</div>
				反光
			</Col>
		</Row>
		<Row type="flex" justify="center" align="center" style="height: 50px;line-height: 50px;">
			<Col span="3">
			</Col>
			<Col span="5">
				<Checkbox v-model="agree">
					<span>同意接受</span>
				</Checkbox>
			</Col>
			<Col span="16">
				<a href="#" style="text-decoration:blink">健康珙县平台相关协议</a>
			</Col>
		</Row>
		<Row type="flex" justify="center" align="center" style="height: 56px;">
			<Col span="3">
			</Col>
			<Col span="18">
				<Button @click="uploadIdCard" :disabled="!submit" long>提交</Button>
			</Col>
			<Col span="3">
			</Col>
		</Row>
	</div>
	
</template>
<script>
	import Top from '../../../assembly'
	export default {
		components: {
			'Layout-Top': Top
		},
		data(){
			return {
				formData:new FormData(),
				agree:true,
				idcard:{
					justUrl:'',
					backUrl:''
				}
			}
		},
		methods:{
			selectIdCard(type){
				if(type=='just'){
					this.$refs.idcard_just.click();
				}else{
					this.$refs.idcard_back.click();
				}
			},
			idcardChang(type){
				if(type=='just'){
					this.idcard.justUrl=this.getObjectURL(this.$refs.idcard_just.files[0]);
				}else{
					this.idcard.backUrl=this.getObjectURL(this.$refs.idcard_back.files[0]);
				}
			},
			uploadIdCard(){
// 				this.formData.append('multipartFiles',this.$ref.idcard_just.files[0],"just");
// 				this.formData.append('multipartFiles',this.$ref.idcard_back.files[0],"back");
// 				this.$http.post('/opinion/feedback', this.formData,{
// 				  headers: {'Content-Type': 'multipart/form-data'}
// 				}).then(res => {
// 					
// 				});
			},
			getObjectURL (file) {
			  let url = null ;
			  if (window.createObjectURL!=undefined) { // basic
				url = window.createObjectURL(file) ;
			  }else if (window.webkitURL!=undefined) { // webkit or chrome
				url = window.webkitURL.createObjectURL(file) ;
			  }else if (window.URL!=undefined) { // mozilla(firefox)
				url = window.URL.createObjectURL(file) ;
			  }
			  return url ;
			}
		},
		computed:{
			submit:function(){
				return this.agree&&this.idcard.justUrl!=''&&this.idcard.backUrl!='';
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/views/WeChat/Person/Account/IdCard/Binding/index.vue